import { render, staticRenderFns } from "./ResumeProgram.vue?vue&type=template&id=0792c073"
import script from "./ResumeProgram.vue?vue&type=script&lang=ts"
export * from "./ResumeProgram.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports